/* WARNING: This file is auto-generated. Do not edit directly.   */
/* To make changes, edit `lib/generators/constants_generator.rb` */
/* To regenerate, run: `rails g constants`                       */

import { ConstantsQuery } from 'queries';

export const BASKETBALL = 1;
export const FOOTBALL = 2;
export const BASEBALL = 3;
export const SOFTBALL = 4;
export const LACROSSE = 5;
export const SOCCER = 6;
export const VOLLEYBALL = 7;
export const FIELD_HOCKEY = 8;
export const ICE_HOCKEY = 9;
export const WATER_POLO = 10;
export const CROSS_COUNTRY = 11;
export const GOLF = 12;
export const TENNIS = 13;
export const WRESTLING = 14;
export const BEACH_VOLLEYBALL = 15;
export const FLAG_FOOTBALL = 16;
export const UNIFIED_BASKETBALL = 17;
export const ULTIMATE_FRISBEE = 18;
export const FENCING = 19;
export const BADMINTON = 20;
export const TRACK_AND_FIELD = 21;
export const GYMNASTICS = 22;

export type SportType = ConstantsQuery['sports'][number];

const SPORTS: SportType[] = [
  {
    id: BASKETBALL,
    name: 'Basketball'
  },
  {
    id: FOOTBALL,
    name: 'Football'
  },
  {
    id: BASEBALL,
    name: 'Baseball'
  },
  {
    id: SOFTBALL,
    name: 'Softball'
  },
  {
    id: LACROSSE,
    name: 'Lacrosse'
  },
  {
    id: SOCCER,
    name: 'Soccer'
  },
  {
    id: VOLLEYBALL,
    name: 'Volleyball'
  },
  {
    id: FIELD_HOCKEY,
    name: 'Field Hockey'
  },
  {
    id: ICE_HOCKEY,
    name: 'Ice Hockey'
  },
  {
    id: WATER_POLO,
    name: 'Water Polo'
  },
  {
    id: CROSS_COUNTRY,
    name: 'Cross Country'
  },
  {
    id: GOLF,
    name: 'Golf'
  },
  {
    id: TENNIS,
    name: 'Tennis'
  },
  {
    id: WRESTLING,
    name: 'Wrestling'
  },
  {
    id: BEACH_VOLLEYBALL,
    name: 'Beach Volleyball'
  },
  {
    id: FLAG_FOOTBALL,
    name: 'Flag Football'
  },
  {
    id: UNIFIED_BASKETBALL,
    name: 'Unified Basketball'
  },
  {
    id: ULTIMATE_FRISBEE,
    name: 'Ultimate Frisbee'
  },
  {
    id: FENCING,
    name: 'Fencing'
  },
  {
    id: BADMINTON,
    name: 'Badminton'
  },
  {
    id: TRACK_AND_FIELD,
    name: 'Track And Field'
  },
  {
    id: GYMNASTICS,
    name: 'Gymnastics'
  }
];

export default SPORTS;
